import service from '@/util/request'

//request() 返回的是一个 Promise
export function getDatas() {
  return service({
    url: '/api/screen/statistics/bigScreenData',
    method: 'get',
  })
}
